var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeaView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "sea-2",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M18,19a5.14,5.14,0,0,1-1.81-.3A3.14,3.14,0,0,0,15,18.5a3.2,3.2,0,0,0-1.19.2A5.14,5.14,0,0,1,12,19a5.21,5.21,0,0,1-1.82-.3A3.1,3.1,0,0,0,9,18.5a3.2,3.2,0,0,0-1.19.2A5.16,5.16,0,0,1,6,19a5.14,5.14,0,0,1-1.81-.3A3.2,3.2,0,0,0,3,18.5a1,1,0,0,1,0-2,5.21,5.21,0,0,1,1.82.3A3.14,3.14,0,0,0,6,17a3.16,3.16,0,0,0,1.19-.2A5.21,5.21,0,0,1,9,16.5a5.25,5.25,0,0,1,1.82.3A3.1,3.1,0,0,0,12,17a3.1,3.1,0,0,0,1.18-.2A5.16,5.16,0,0,1,15,16.5a5.14,5.14,0,0,1,1.81.3,3.61,3.61,0,0,0,2.37,0A5.14,5.14,0,0,1,21,16.5a1,1,0,0,1,0,2,3.1,3.1,0,0,0-1.18.2A5.16,5.16,0,0,1,18,19Z",
    style: {
      fill: "#b97d6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M21,15a.84.84,0,0,1-.27,0c-2.43-.68-2.72-2.75-3-4.58a4.19,4.19,0,0,0-2.43-3.11,3.93,3.93,0,0,0-3.11.11,4.41,4.41,0,0,1,1.92,3.25,2.79,2.79,0,0,1-1.79,2.91,4.46,4.46,0,0,1-3.08-.18c-1.14-.36-2-.64-3.28.24l-.29.21A5.1,5.1,0,0,1,3.11,15a1,1,0,1,1-.22-2,3.32,3.32,0,0,0,1.63-.82L4.83,12a5.08,5.08,0,0,1,5-.52,2.78,2.78,0,0,0,1.78.22.84.84,0,0,0,.49-.92A2.78,2.78,0,0,0,9.83,8.47a1,1,0,0,1-.75-.77,1,1,0,0,1,.38-1C11.69,5,14.05,4.57,16.09,5.42A6.2,6.2,0,0,1,19.73,10c.29,2,.46,2.69,1.54,3A1,1,0,0,1,21,15Z",
    style: {
      fill: "#000000"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaView);
export default __webpack_public_path__ + "static/media/sea-view.3ce409c175f010dbbaf0df39261d60e6.svg";
export { ForwardRef as ReactComponent };